import React, { useEffect, useState } from 'react';
import { AccordionItem, useAccordionProvider, ControlledAccordion } from '@szhsin/react-accordion';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './Accordion.scss';
import './Accordion-media.scss';
import { IAccordion } from './interfaces';

const Accordion = ({ title, content, expanded }: IAccordion) => {
  const [open, setOpen] = useState(false);

  const providerValue = useAccordionProvider({
    allowMultiple: true,
    transition: true,
    transitionTimeout: 250,
  });
  const { toggle } = providerValue;
  const Toggle = (e: any) => {
    if (
      e.target.localName !== 'a' &&
      e.target.localName !== 'p' &&
      e.target.localName !== 'h4' &&
      !e.target.classList.contains('accordion__expend')
    ) {
      setOpen(!open);
      toggle('acc');
    }
  };

  return (
    <div className="accordion" onClick={Toggle}>
      <ControlledAccordion providerValue={providerValue}>
        <AccordionItem
          initialEntered={expanded}
          itemKey="acc"
          header={
            <div className="accordion__title">
              <h4 dangerouslySetInnerHTML={{ __html: title }}></h4>
              <div className="accordion__expend" />
            </div>
          }
        >
          <p dangerouslySetInnerHTML={{ __html: content }}></p>
        </AccordionItem>
      </ControlledAccordion>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(Accordion));
